import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f9dd4262")

_pushScopeId("data-v-f9dd4262")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row justify-content-md-center" }
const _hoisted_3 = { class: "col-lg-4 col-md-6 col-sm-12 login-form text-white" }
const _hoisted_4 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "row justify-content-center" }
const _hoisted_8 = { class: "col-lg-8 col-md-10 col-sm-12" }
const _hoisted_9 = { class: "form-group text-left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_11 = { class: "form-group text-left" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/_createVNode("small", { class: "text-primary" }, "Forgot your password ?", -1)
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"row justify-content-center\" data-v-f9dd4262><div class=\"col-8\" data-v-f9dd4262><button type=\"submit\" class=\"btn btn-block form-control\" data-v-f9dd4262><span class=\"text-white\" data-v-f9dd4262>Login</span></button></div></div><div class=\"row mt-3\" data-v-f9dd4262><div class=\"col\" data-v-f9dd4262><small class=\"text-muted\" data-v-f9dd4262> This site is protected by reCAPTCHA and the Google <a href=\"https://policies.google.com/privacy\" data-v-f9dd4262> Privacy Policy </a> and <a href=\"https://policies.google.com/terms\" data-v-f9dd4262> Terms of Service </a> apply. </small></div></div>", 2)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Verify2fa = _resolveComponent("Verify2fa")
  const _component_TheBanner = _resolveComponent("TheBanner")
  const _component_Password = _resolveComponent("Password")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Verify2fa, {
      show: _ctx.showVerify,
      email: _ctx.email,
      onClose: _ctx.close2fa,
      onSuccess: _ctx.success2fa
    }, null, 8, ["show", "email", "onClose", "onSuccess"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_TheBanner),
          _hoisted_5,
          _hoisted_6,
          _createVNode("div", _hoisted_7, [
            _createVNode("div", _hoisted_8, [
              _createVNode("form", {
                id: "login",
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["stop","prevent"]))
              }, [
                _createVNode("div", _hoisted_9, [
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "email",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                    "aria-describedby": "emailHelp",
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$v.email.$touch())),
                    placeholder: "Enter admin email"
                  }, null, 544), [
                    [_vModelText, _ctx.email]
                  ])
                ]),
                _hoisted_10,
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_Password, {
                    style: {"width":"100%"},
                    inputStyle: "width:100%",
                    toggleMask: "",
                    feedback: false,
                    modelValue: _ctx.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.password = $event)),
                    placeholder: "Password"
                  }, null, 8, ["modelValue"])
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_router_link, { to: { name: 'auth.forgot' } }, {
                    default: _withId(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _hoisted_14
              ], 32)
            ])
          ])
        ])
      ])
    ])
  ], 64))
})